var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{scopedSlots:_vm._u([{key:"banner",fn:function(){return [_c('Banner',{attrs:{"title":_vm.title,"src-desktop":require('@/assets/search/banner.png'),"src-mobile":require('@/assets/search/banner-mobile.png')}})]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }